import { useRouter } from 'next/router';
// import { useEffect, useState } from 'react';
// import Script from 'next/script';
// import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
// import { GoogleTagManager } from '@next/third-parties/google';
import Nav from '@/components/nav';
import Footer from '@/components/footer';
import AgeGate from '@/components/age-gate/age-gate-location';
// import { Link } from '@aws-amplify/ui-react';

const hideFromRoutes = [
  '/cart',
  '/test/icons',
  '/test/hero',
  '/test/cart',
];

const shouldHideLayout = (pathname) =>
  hideFromRoutes.includes(pathname) || pathname.startsWith('/receipt/');

export default function Layout({ children, router: propRouter }) {
  const router = useRouter();
  const pathname = propRouter?.pathname || router.pathname;
  const hide = shouldHideLayout(pathname);

  // const [hasConsent, setHasConsent] = useState(false);

  // useEffect(() => {
  //   const consent = getCookieConsentValue("cookieConsent");
  //   if (consent === "true") {
  //     setHasConsent(true);
  //     window.gtag && window.gtag('consent', 'update', {
  //       ad_storage: 'granted',
  //       analytics_storage: 'granted'
  //     });
  //   } else {
  //     window.gtag && window.gtag('consent', 'update', {
  //       ad_storage: 'denied',
  //       analytics_storage: 'denied'
  //     });
  //   }
  // }, []);

  return (
    <div className={hide ? '' : 'content-wrap'}>
      {/* ✅ Consent Mode Initialization (ALWAYS runs first) */}
      {/* <Script id="gtm-consent-init" strategy="beforeInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('consent', 'default', {
            ad_storage: 'denied',
            analytics_storage: 'denied'
          });
        `}
      </Script> */}

      {/* ✅ Always load GTM, Consent Mode handles behavior */}
      {/* <GoogleTagManager gtmId="GTM-KQQS78R" /> */}

      <AgeGate router={router} />
      {!hide && <Nav pathname={pathname} />}
      <main>{children}</main>
      {!hide && <Footer />}

      {/* ✅ Cookie Banner */}
      {/* <CookieConsent
        onAccept={() => {
          setHasConsent(true);
          window.gtag && window.gtag('consent', 'update', {
            ad_storage: 'granted',
            analytics_storage: 'granted',
          });
        }}
        onDecline={() => {
          setHasConsent(false);
          window.gtag && window.gtag('consent', 'update', {
            ad_storage: 'denied',
            analytics_storage: 'denied',
          });
        }}
        enableDeclineButton
        location="bottom"
        cookieName="cookieConsent"
        buttonText="Accept"
        declineButtonText="Decline"
        style={{ background: "var(--clr-neutral-850)" }}
        buttonWrapperClasses="cookie-consent-buttons"
        buttonStyle={{
          background: "var(--clr-accent-300)",
          color: "var(--clr-neutral-100)",
          fontSize: "16px",
          borderRadius: "4px",
          marginRight: "0.5rem"
        }}
        declineButtonStyle={{
          background: "transparent",
          color: "var(--clr-neutral-100)",
          fontSize: "16px",
          borderRadius: "4px",
          border: "1px solid var(--clr-neutral-500)"
        }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.{" "}
        <Link href="/privacy-policy">Learn more</Link>
      </CookieConsent> */}
    </div>
  );
}
